import React from 'react'
import { useTween } from 'react-use'

import { FluidBox } from 'styled'
import PeopleChart from 'components/PeopleChart'
import QuestionBox from './../ThemesPanel/QuestionBox'

import {
  Root,
  OptionList,
  OptionRow,
  PctBox,
  GraphicsBox,
  QuestionWrapper,
} from './AnswersPanel.styled.js'

const calcOptionPct = (result, optionId, total) => {
  const resultOption = result.filter(r => r.optionId === optionId)

  if (resultOption.length === 0) {
    return 0
  } else {
    return resultOption[0].count / total
  }
}

const ListItem = ({
  option,
  optionPct,
  optionId,
  userAnswer,
  question,
  entering,
  leaving,
  navDirection,
}) => {
  const tween = useTween('linear', 700, 1200)

  return (
    <OptionRow
      entering={entering}
      leaving={leaving}
      nth={optionId}
      navDirection={navDirection}
      color={
        question.correct === optionId ? 'accent' : userAnswer === optionId ? 'wrong' : 'primary'
      }
    >
      <PctBox mr="spaceNormal">
        {question.correct === optionId && (
          <FluidBox fw="light" fs="textSmall" mb="spaceXs">
            This is the correct answer
          </FluidBox>
        )}
        <FluidBox as="span" fw="bold" color="body">
          {`${(100 * optionPct * tween).toFixed(1)}% of people answered`}
        </FluidBox>
        <FluidBox fs={[18, 18, 18, 18]} fw="bold" py="spaceXs">
          Option {optionId + 1}: {option}
        </FluidBox>
        {userAnswer === optionId && (
          <FluidBox fw="light" fs="textSmall">
            This was your answer
          </FluidBox>
        )}
      </PctBox>
      <GraphicsBox pr="spaceLarge" w={[320, 320, 320, 400]}>
        <PeopleChart
          pct={optionPct * tween}
          uid={`${question.questionId}_${optionId}`}
        ></PeopleChart>
      </GraphicsBox>
    </OptionRow>
  )
}

const AnswersPanel = ({ result, question, userAnswer, entering, leaving, navDirection }) => {
  const totalAnswers = result.reduce((total, res) => {
    total += res.count
    return total
  }, 0)

  return (
    <Root py="spaceNormal">
      <div className="Inner">
        <QuestionWrapper entering={entering} leaving={leaving} navDirection={navDirection}>
          <QuestionBox
            question={question}
            selected={true}
            correct={userAnswer === question.correct}
            selectedTheme={true}
          ></QuestionBox>
        </QuestionWrapper>
        <OptionList py="spaceNormal">
          {question.options.map((option, id) => (
            <ListItem
              key={id}
              optionPct={calcOptionPct(result, id, totalAnswers)}
              optionId={id}
              userAnswer={userAnswer}
              option={option}
              question={question}
              entering={entering}
              leaving={leaving}
              navDirection={navDirection}
            ></ListItem>
          ))}
        </OptionList>
      </div>
    </Root>
  )
}

export default AnswersPanel
